module.exports = __webpack_public_path__ + "img/arh_10.6edcfa7b.jpg";